<template>
	<div class="heatnews">
		<div class="topcon">
			<div :class="sign == 0?'title_cur':'title'" @click="changesing(0)">热点新闻</div>
			<div :class="sign == 1?'title_cur':'title'" style="margin-left: 60px;" @click="changesing(1)">全国青年志愿者风采展示</div>
			<div :class="sign == 2?'title_cur':'title'" style="margin-left: 60px;" @click="changesing(2)">个人及青少年风采展示</div>
		</div>
		
		<div class="carcon">
			<div class="l_c" v-if='listData.length>0' @click="$util.goPage('newDetail',type,listData[0].id)">
				<div class="imgcon">
					<img :src="$util.imgSrc(listData[0].thumbnail?listData[0].thumbnail:listData[0].thumbnail_dictText)" />
				</div>
				<div class="inform">
					<div class="title">{{listData[0].title?listData[0].title:''}}</div>
					<div class="time">{{listData[0].pubTime|timeFilter}}</div>
				</div>
			</div>
			<div class="r_c">
				<div v-if='listData.length>0'>
					<div class="signle" v-for="(item,index) in listData" :key="index" @click="$util.goPage('newDetail',type,item.id)" >
						<div class="topline"></div>
						<div class="timeandtitle">
							<div class="time">
								<div class="day">{{$util.getTimeDay(item.pubTime)}}</div>
								<div class="yearmonth">{{$util.getTimeYM(item.pubTime)}}</div>
							</div>
							<div class="title w-max">{{item.title?item.title:''}}</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
		
		<div class="morecon" @click="$util.goPage('news',type)">
			<span>查看更多</span>
			<img src="../../assets/img/leftarrow@2x.png" />
		</div>
		
	</div>
	
</template>

<script>


export default {
  props:['hotNews','youthInfoList','selfYouthList'],

  data: function() {
	  var self=this;
		return {
			sign:0,
			type:28,
		};
  },
  filters:{ 
	  timeFilter:function(val){
		  var str=''
		  if(val){ 
			  str=val.split(' ')[0];
			  str=str.replace('-', '.').replace('-', '.')
		  }
		  return str
	  },
  },
  computed:{ 
	  listData:function(){ 
		  var arr=[]
		  if(this.sign=='0'){ 
			 arr= this.hotNews
			 this.type=28
		  }
		  if(this.sign=='1'){ 
			arr= this.youthInfoList
			 this.type=29
		  }
		  if(this.sign=='2'){ 
			arr= this.selfYouthList
			 this.type=30
		  }
		  return arr
	  }
  },
  watch:{
	  $route(to,from,next){
		if(to.path.indexOf('/youthVolunteer')!=-1){ 
			this.changesing(0)
		}
    },
  },
  mounted() {
	// console.log('mounted')
	this.changesing(this.sign)
  },

  methods: {
	changesing(sign){
		this.sign = sign
	},
	
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.heatnews{
	
	.topcon{
		height: 80px;
		display: flex;
		align-items: center;
		border-bottom: 2px solid #F1F1F1;
		.title_cur{
			cursor: pointer;
			line-height: 80px;
			border-bottom: 5px solid #BA0711;
			font-size: 28px;
			font-weight: bold;
			color: #BA0711;
		}
		.title{
			cursor: pointer;
			line-height: 80px;
		}
		.title:hover{
			cursor: pointer;
			line-height: 80px;
			border-bottom: 5px solid #BA0711;
			font-size: 28px;
			font-weight: bold;
			color: #BA0711;
		}
	}
	
	.carcon{
		margin-top: 60px;
		display: flex;
		.l_c{
			flex:1;	
			.imgcon{
				cursor: pointer;
				width: 556px;
				max-height: 371px;
				overflow: hidden;
				img{
					width: 100%;
					// height: 100%;
				}
			}
			.inform{
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 556px;
				margin-top: 10px;
				.title{
					cursor: pointer;
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
				.time{
					cursor: pointer;
					font-size: 16px;
					font-weight: 400;
					color: #333333;
				}
			}
			.inform:hover{ 
				.title{
					color: #A62725;
				}
				.time{
					color: #A62725;
				}
			}
		}
		.r_c{
			margin-top: 10px;
			flex:1;
			.signle{
				.topline{
					width: 60px;
					height: 3px;
					background: #A62725;
				}
				.timeandtitle{
					margin-top: 40px;
					margin-bottom: 40px;
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					.time{
						width: 60px;
						.day{
							cursor: pointer;
							font-size: 30px;
							font-weight: 500;
							color: #333333;
							text-align: center;
						}
						.yearmonth{
							cursor: pointer;
							font-size: 16px;
							font-weight: 400;
							color: #333333;
						}
					}
					.title{
						width: calc(100% - 100px);
						cursor: pointer;
						// flex: 1;
						margin-left: 40px;
						font-size: 16px;
						font-weight: 400;
						color: #333333;
					}
				}
				.timeandtitle:hover .time .day{
					color: #A62725;
				}
				.timeandtitle:hover .time .yearmonth{
					color: #A62725;
				}
				.timeandtitle:hover .title{
					color: #A62725;
				}
				
			}
		}
	}
	
	.morecon{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 80px;
		margin-top: 20px;
		span{
			cursor: pointer;
			font-size: 16px;
			font-weight: 400;
			color: #AA0F14;
			margin-right: 30px;
		}
		img{
			cursor: pointer;
			height: 34px;
			width: 34px;
			margin-left: 30px;
		}
	}
	
	
}

</style>
